/* Free mystery air freshener on product/collection pages: picks the design, plays the pack reveal. Shares the design list with the homepage cart. */
(() => {
  const RK = 'inc_mys_v1';
  let R = [];
  try { const x = JSON.parse(localStorage.getItem(RK) || '[]'); if (Array.isArray(x)) R = x; } catch (_) {}
  const saveR = () => { try { localStorage.setItem(RK, JSON.stringify(R)); } catch (_) {} };
  const pool = () => (window.INC_POOL || []);
  const pick = () => {
    if (window.INC_PICK) { const x = window.INC_PICK(R); if (x) return x; }
    const P = pool(); if (!P.length) return { n: 'Mystery design', s: '', seen: 0 };
    const have = new Set(R.map(r => r && r.n)); const fresh = P.filter(p => !have.has(p.n));
    const L = fresh.length ? fresh : P; const p = L[Math.floor(Math.random() * L.length)];
    return { n: p.n, s: p.s, seen: 0 };
  };
  const paintAll = () => {};
  /* ---------- reveal animation (trading-card pack) ---------- */
  const css = document.createElement('style');
  css.textContent = `
.mr-sc{position:fixed;inset:0;z-index:120;display:grid;place-items:center;background:rgba(0,0,0,.78);backdrop-filter:blur(6px);opacity:0;transition:opacity .25s}
.mr-sc.on{opacity:1}
.mr-st{display:grid;justify-items:center;gap:18px;padding:24px 16px;text-align:center;width:min(100%,360px)}
.mr-eb{font-family:var(--f-mono,monospace);font-size:11px;letter-spacing:.12em;text-transform:uppercase;color:var(--gold,#e3b04b)}
.mr-stage{position:relative;width:200px;height:280px;perspective:900px}
.mr-pack,.mr-card{position:absolute;inset:0;border-radius:16px}
.mr-pack{display:grid;place-items:center;background:linear-gradient(135deg,#2a2210,#e3b04b 35%,#fff3c4 50%,#e3b04b 65%,#2a2210);background-size:250% 250%;box-shadow:0 20px 60px rgba(227,176,75,.35);animation:mrfoil 2.2s linear infinite,mrshake .55s ease-in-out .35s 2;cursor:pointer;overflow:hidden;border:0;padding:0}
.mr-pack::before{content:"";position:absolute;inset:10px;border:2px solid rgba(0,0,0,.35);border-radius:10px}
.mr-pack b{font-family:var(--f-display,system-ui);font-size:86px;line-height:1;color:#141008;text-shadow:0 2px 0 rgba(255,255,255,.4)}
.mr-pack small{position:absolute;bottom:22px;left:0;right:0;font-family:var(--f-mono,monospace);font-size:10px;letter-spacing:.14em;color:#141008}
.mr-top{position:absolute;left:0;right:0;top:0;height:44px;background:inherit;border-bottom:2px dashed rgba(0,0,0,.4);border-radius:16px 16px 0 0}
.mr-sc.tear .mr-top{animation:mrtear .5s cubic-bezier(.3,.7,.4,1) forwards}
.mr-sc.tear .mr-pack{animation:mrdrop .5s ease-in .35s forwards}
.mr-card{transform-style:preserve-3d;transform:translateY(40px) rotateY(180deg) scale(.85);opacity:0}
.mr-sc.flip .mr-card{animation:mrflip .8s cubic-bezier(.2,.8,.2,1) forwards}
.mr-f,.mr-b{position:absolute;inset:0;border-radius:16px;backface-visibility:hidden;overflow:hidden}
.mr-b{transform:rotateY(180deg);background:linear-gradient(135deg,#2a2210,#e3b04b,#2a2210)}
.mr-f{background:#111;border:2px solid var(--gold,#e3b04b);box-shadow:0 0 50px rgba(227,176,75,.45)}
.mr-f img{width:100%;height:100%;object-fit:cover}
.mr-f::after{content:"";position:absolute;inset:-40%;background:linear-gradient(115deg,transparent 40%,rgba(255,255,255,.55) 50%,transparent 60%);transform:translateX(-100%);animation:mrshine 1.4s ease-out 1.1s}
.mr-nm{display:grid;gap:4px;opacity:0;transform:translateY(8px);transition:.35s .2s}
.mr-sc.done .mr-nm{opacity:1;transform:none}
.mr-nm b{font-family:var(--f-display,system-ui);font-size:24px;line-height:1.1;color:#fff}
.mr-nm span{font-size:13px;color:#d6d3cd}
.mr-nm em{font-style:normal;font-family:var(--f-mono,monospace);font-size:11px;color:var(--gold,#e3b04b);letter-spacing:.08em}
.mr-go{border:0;border-radius:999px;padding:12px 26px;background:var(--gold,#e3b04b);color:#000;font:inherit;font-weight:700;cursor:pointer;opacity:0;transition:opacity .3s .4s}
.mr-sc.done .mr-go{opacity:1}
.mr-hint{font-size:12.5px;color:#a19e99}
.mr-sc.tear .mr-hint{visibility:hidden}
@keyframes mrfoil{to{background-position:250% 250%}}
@keyframes mrshake{0%,100%{transform:rotate(0)}25%{transform:rotate(-4deg)}75%{transform:rotate(4deg)}}
@keyframes mrtear{to{transform:translate(70px,-160px) rotate(28deg);opacity:0}}
@keyframes mrdrop{to{transform:translateY(120px);opacity:0}}
@keyframes mrflip{0%{opacity:1;transform:translateY(40px) rotateY(180deg) scale(.85)}60%{transform:translateY(-14px) rotateY(-12deg) scale(1.04);opacity:1}100%{transform:none;opacity:1}}
@keyframes mrshine{to{transform:translateX(100%)}}
@media (prefers-reduced-motion:reduce){.mr-pack{animation:none}.mr-sc.tear .mr-top,.mr-sc.tear .mr-pack{animation:none;opacity:0}.mr-sc.flip .mr-card{animation:none;opacity:1;transform:none}.mr-f::after{display:none}}
.cl.gift.mr-rev small{color:var(--gold,#e3b04b)}
@media (max-height:720px){.mr-stage{width:150px;height:210px}.mr-pack b{font-size:64px}.mr-st{gap:12px}}
`;
  document.head.appendChild(css);

  let Q = [], busy = false;
  function play(r, i, n) {
    return new Promise(res => {
      const sc = document.createElement('div');
      sc.className = 'mr-sc'; sc.setAttribute('role', 'dialog'); sc.setAttribute('aria-modal', 'true'); sc.setAttribute('aria-label', 'Your free air freshener');
      sc.innerHTML = `<div class="mr-st"><span class="mr-eb">Deal unlocked${n > 1 ? ` · ${i + 1} of ${n}` : ''}</span>
<div class="mr-stage"><div class="mr-card"><div class="mr-b"></div><div class="mr-f"><img alt="" src="${r.s}"></div></div>
<button type="button" class="mr-pack" aria-label="Open your mystery pack"><span class="mr-top"></span><b>?</b><small>MYSTERY · AIR FRESHENER</small></button></div>
<span class="mr-hint">Tap the pack to open it</span>
<div class="mr-nm" aria-live="polite"><em>YOU PULLED</em><b></b><span>Free with your accessories · added to your cart</span></div>
<button type="button" class="mr-go">Nice, keep shopping</button></div>`;
      sc.querySelector('.mr-nm b').textContent = r.n;
      document.body.appendChild(sc);
      requestAnimationFrame(() => sc.classList.add('on'));
      let opened = false;
      const open = () => {
        if (opened) return; opened = true;
        sc.classList.add('tear');
        setTimeout(() => sc.classList.add('flip'), 450);
        setTimeout(() => { sc.classList.add('done'); sc.querySelector('.mr-go').focus(); }, 1250);
      };
      const auto = setTimeout(open, 1600);
      sc.querySelector('.mr-pack').addEventListener('click', () => { clearTimeout(auto); open(); });
      const close = () => { clearTimeout(auto); sc.classList.remove('on'); setTimeout(() => { sc.remove(); res(); }, 220); };
      sc.querySelector('.mr-go').addEventListener('click', close);
      sc.addEventListener('click', e => { if (e.target === sc && sc.classList.contains('done')) close(); });
      sc.addEventListener('keydown', e => { if (e.key === 'Escape') { if (!opened) open(); else close(); } });
      sc.querySelector('.mr-pack').focus();
    });
  }
  async function drain() {
    if (busy) return; busy = true;
    const n = Q.length;
    for (let i = 0; Q.length; i++) { const k = Q.shift(); await play(R[k], i, n); R[k].seen = 1; saveR(); paintAll(); }
    busy = false;
  }


  window.INCM = {
    get(k) { if (!R[k]) { R[k] = pick(); saveR(); } return R[k]; },
    // sealed: the design stays a surprise until the Thank-you page (Mystery pack reveal app block)
    reveal(ks) { if (window.INC_SEALED) return; ks.forEach(k => { if (R[k] && !Q.includes(k)) Q.push(k); }); if (Q.length) setTimeout(drain, 300); }
  };
})();
